<template>
  <div>
    <!-- UsuariosAdminView -->
  </div>
</template>

<script>
export default {
  name: 'UsuariosAdminView'
}
</script>



// WEBPACK FOOTER //
// src/views/admin/UsuariosAdminView.vue